import { render, staticRenderFns } from "./PageServiceDashboard.vue?vue&type=template&id=095e775c&scoped=true&"
import script from "./PageServiceDashboard.vue?vue&type=script&lang=js&"
export * from "./PageServiceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PageServiceDashboard.vue?vue&type=style&index=0&id=095e775c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e775c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VTooltip})
